import DefaultKpiContainer from "containers/Organisation/DefaultKpiContainer";

import DefaultKpiScreen from './DefaultKpiScreen';

export default DefaultKpiScreen;
